export default __webpack_public_path__ + "static/media/pat fallon.1e318a68.jpg";